module.exports = __webpack_public_path__ + "media/auth/sign_up-bca59573.svg";